import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { State, STATES } from '../../../../shared/models/state';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { DatePipe, formatDate } from '@angular/common';
import { ValidationService } from '../../../services/validation.service';
import { BrandSeed } from '../../../models/BrandSeed';
import { BrandSeedService } from '../../../services/brandSeed.service';

@Component({
  selector: 'app-brand-seed-form',
  templateUrl: './brand-seed-form.component.html' 
})

export class BrandSeedFormComponent implements OnInit {
 
  //input/output parameters
  @Input() title;
  @Input() inputModel: BrandSeed;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  modelForm: FormGroup; 
  submitted = false;  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public stateList: State[] = STATES;  // bind list of states
  public campaignTypeList: CampaignType[];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private brandSeedService: BrandSeedService,
    private storeLocationService: StoreLocationService,
    private campaignTypeService: CampaignTypeService,
    private notification: MatSnackBar) { }

  // on component load
  ngOnInit() { 
     
    // bind store locations dropdown
    this.storeLocationService.getAll(this.inputModel.brandId).subscribe(locationResult => {
      this.storeLocationList = locationResult;
    });

    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult;
    });

    const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;

    this.modelForm = this.formBuilder.group({
      id: [this.inputModel.id],
      patientId: [this.inputModel.patientId],
      clxPatientId: [this.inputModel.clxPatientId],
      firstName: [this.inputModel.firstName, Validators.required],
      lastName: [this.inputModel.lastName, Validators.required],
      address1: [this.inputModel.address1, Validators.required],
      address2: [this.inputModel.address2 ],
      city: [this.inputModel.city, [Validators.required, ValidationService.alphaNumericSpecialCharactersValidator]],
      state: [this.inputModel.state, Validators.required],
      zipCode: [this.inputModel.zipCode, [Validators.required, ValidationService.zipCodeValidator]],
      gender: [this.inputModel.gender, Validators.required],
      dateOfBirth: [(this.inputModel.dateOfBirth !== null && this.inputModel.dateOfBirth !== undefined && this.inputModel.dateOfBirth !== '' ? formatDate(this.inputModel.dateOfBirth, 'MM/dd/yyyy', 'en-US') : null), Validators.pattern(dateReg)],
      //lastExamDate: [(this.inputModel.lastExamDate !== null && this.inputModel.lastExamDate !== undefined && this.inputModel.lastExamDate !== '' ? formatDate(this.inputModel.lastExamDate, 'MM/dd/yyyy', 'en-US') : null), [Validators.pattern(dateReg)]],
      months: [this.inputModel.months, [Validators.min(0), Validators.required, ValidationService.numericValidator]],
      phone: [this.inputModel.phone, ValidationService.phoneValidator],
      email: [this.inputModel.email, Validators.email],
      brandId: [this.inputModel.brandId, Validators.required],
      campaignTypeId: [this.inputModel.campaignTypeId, [Validators.required, Validators.min(1)]],
      storeLocationId: this.inputModel.storeLocationId,
      custom1: [this.inputModel.custom1],
      custom2: [this.inputModel.custom2],
      custom3: [this.inputModel.custom3],
      custom4: [this.inputModel.custom4],
      custom5: [this.inputModel.custom5],
    });
     
  }

  // format date  
  formatDate(e, fieldName: string) {
    if (e.target.value === null) {
      this.modelForm.get(fieldName).setValue('', {
        onlyself: true
      })
    }
    else {
      var convertDate = new Date(e.target.value);

      this.modelForm.get(fieldName).setValue(convertDate, {
        onlyself: true
      })
    }
  }

  transformDate(dateStr: string): string {
    const dateSendingToServer = new DatePipe('en-US').transform(dateStr, 'dd/MM/yyyy')
    return dateSendingToServer;
  }

  // handle form submit  
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.modelForm.invalid) {
        return; 
    }

    let formValues = this.modelForm.value as BrandSeed;
    formValues.id = +this.modelForm.value['id'];
    formValues.brandId = +this.modelForm.value['brandId'];
    formValues.campaignTypeId = +this.modelForm.value['campaignTypeId'];
    formValues.storeLocationId = +this.modelForm.value['storeLocationId'];
    formValues.dateOfBirth = this.modelForm.value['dateOfBirth'];
    formValues.lastExamDate = this.modelForm.value['lastExamDate'];
    formValues.months = +this.modelForm.value['months'];

    //add
    if (formValues.id == 0) {
      this.brandSeedService.add(formValues).subscribe(brandSeed => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandSeed);
        this.showNotification(`The new seed was successuly added!`, 'Okay!')
      });
    // update
    } else {
      this.brandSeedService.update(formValues.id, formValues).subscribe(brandSeed => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandSeed);
        this.showNotification(`The entry was successuly updated!`, 'Okay!') 
      });
    }  
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  } 

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
